/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PatternQualifier = {
    CaseInsensitive: 'case_insensitive'
} as const;
export type PatternQualifier = typeof PatternQualifier[keyof typeof PatternQualifier];


export function instanceOfPatternQualifier(value: any): boolean {
    for (const key in PatternQualifier) {
        if (Object.prototype.hasOwnProperty.call(PatternQualifier, key)) {
            if (PatternQualifier[key as keyof typeof PatternQualifier] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PatternQualifierFromJSON(json: any): PatternQualifier {
    return PatternQualifierFromJSONTyped(json, false);
}

export function PatternQualifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatternQualifier {
    return json as PatternQualifier;
}

export function PatternQualifierToJSON(value?: PatternQualifier | null): any {
    return value as any;
}

export function PatternQualifierToJSONTyped(value: any, ignoreDiscriminator: boolean): PatternQualifier {
    return value as PatternQualifier;
}

